import $ from "jquery";
(function ($) {
    function toggleLoading(element){
        element.toggleClass('ajaxloading');
    }

    function addParameterToURL(url,param){
        url += (url.split('?')[1] ? '&':'?') + param;
        return url;
    }
    $.infiniteScroll = function (el, options) {

        var defaults = {
            listElement: '.news-list-view',
            paginator: '.page-navigation',
            nextLink: '.last.next a',
            pageType: 1984,
            itemSelector: '.grid-item',
            loadCounter: 2,
            offsetViewport: 0,
            onItemLoaded: function (result) {
                if (container.length > 0){
                    $(plugin.settings.listElement).append($(result).find(plugin.settings.itemSelector));
                }
            },
            onFailure: function () {
            },
            onFinish: function () {
            }
        };

        // holds reference to the next link to load
        var nextLink = null, paginator = null, counter = 0, container = null;

        var plugin = this;

        plugin.settings = {};

        var init = function () {
            plugin.settings = $.extend({}, defaults, options);
            container = $(plugin.settings.listElement);
            paginator = $(plugin.settings.paginator);
            bindNextLink();
        };

        var bindClickHandler = function (element) {
            element.on("click", function () {
                $( window ).unbind('scroll');
                requestNewPage();
                return false;
            });
            if(plugin.settings.loadCounter === null || plugin.settings.loadCounter > 0){
                if(plugin.settings.loadCounter === counter){
                    return false;
                }
                $( window ).scroll(function () {
                    if(isInViewport(element[0])){
                        counter++;
                        element.click();
                    }
                });
            }
        };

        var bindNextLink = function () {
            if(paginator.find(plugin.settings.nextLink).length > 0){
                nextLink = paginator.find(plugin.settings.nextLink).attr('href');
                bindClickHandler(paginator.find(plugin.settings.nextLink));
            }
        };

        var updatePaginator = function (result) {
            paginator.remove();
            paginator = $(result).find(plugin.settings.paginator);
            container.append(paginator);
        };

        var isInViewport = function (element) {
            var rect = element.getBoundingClientRect();
            var html = document.documentElement;
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom - plugin.settings.offsetViewport <= (window.innerHeight || html.clientHeight) &&
                rect.right <= (window.innerWidth || html.clientWidth)
            );
        };

        var requestNewPage = function () {
            // event.preventDefault();
            toggleLoading(paginator);
            if (nextLink == null) return;
            $.ajax({
                url: addParameterToURL(nextLink,"type="+plugin.settings.pageType)
            }).fail(function () {
                plugin.settings.onFailure(this);
            }).done(function (result) {
                plugin.settings.onItemLoaded(result);
            }).always(function (result) {
                plugin.settings.onFinish(result);
                updatePaginator(result);
                bindNextLink();
            });
            return false;
        };
        init();
    }
})($);
